import { useSyncExternalStore } from 'react';

/**
 * Modo impressao.
 *
 * O PDF e a impressao fotografam a tela: o que estiver paginado sai cortado.
 * Enquanto este sinal esta ligado, as listas com "Ver mais" renderizam tudo o
 * que ja carregaram - e voltam ao normal assim que a captura termina.
 */
let imprimindo = false;
const ouvintes = new Set<() => void>();

function avisar() {
  for (const ouvinte of ouvintes) ouvinte();
}

export function setPrintMode(ativo: boolean): void {
  if (imprimindo === ativo) return;

  imprimindo = ativo;
  avisar();
}

/**
 * Liga o modo, espera o React repintar com a lista inteira e so entao executa
 * a captura. Sem os dois frames, a foto sai com o que estava antes.
 */
export async function withPrintMode<T>(acao: () => Promise<T> | T): Promise<T> {
  setPrintMode(true);

  try {
    await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
    return await acao();
  } finally {
    setPrintMode(false);
  }
}

export function usePrintMode(): boolean {
  return useSyncExternalStore(
    (ouvinte) => {
      ouvintes.add(ouvinte);
      return () => ouvintes.delete(ouvinte);
    },
    () => imprimindo,
    () => false,
  );
}
